import React from 'react';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { Box, SxProps } from '@mui/material';
import { getOutlinedButtonStyles, IOutlinedButtonStyles } from './outlinedButton.styles';

interface OutlinedButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  styleOverrides?: Partial<IOutlinedButtonStyles>;
  className?: string;
  startIcon?: React.ReactNode;
  gradientOutline?: boolean; // Optional prop for gradient background
  disabled?: boolean;
  sx?: SxProps;
}

const OutlinedButton: React.FC<OutlinedButtonProps> = ({
  children,
  onClick,
  styleOverrides,
  className,
  startIcon,
  gradientOutline = true,
  disabled = false,
  sx,
}) => {
  const theme = useTheme();
  const styles = getOutlinedButtonStyles(theme, styleOverrides, gradientOutline);

  return (
    <Box sx={styles.root}>
      <Button
        variant="outlined"
        sx={
          {
            ...styles.outlinedButton,
            ...styleOverrides?.outlinedButton,
            ...sx,
          } as SxProps
        }
        onClick={onClick}
        className={className}
        startIcon={startIcon}
        disabled={disabled}
      >
        {children}
      </Button>
    </Box>
  );
};

export default OutlinedButton;
